import { getThreatReviewStatsBySource } from "@/services";
import { useQuery } from "@tanstack/react-query";

const THREAT_REVIEW_STATS_QUERY_KEY = ["threat-review-stats"] as const;

export function useThreatReviewStats() {
  return useQuery({
    queryKey: THREAT_REVIEW_STATS_QUERY_KEY,
    queryFn: async () => {
      const response = await getThreatReviewStatsBySource();
      return response ?? null;
    },
    staleTime: 0,
    gcTime: 0,
  });
}
